import { render, staticRenderFns } from "./Depreciation.vue?vue&type=template&id=bb43aec4&scoped=true&"
import script from "./Depreciation.vue?vue&type=script&lang=js&"
export * from "./Depreciation.vue?vue&type=script&lang=js&"
import style0 from "./Depreciation.vue?vue&type=style&index=0&id=bb43aec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb43aec4",
  null
  
)

export default component.exports